import $ from 'jquery';
import { Autoplay, Navigation, Swiper } from 'swiper';

import { $Elements, BrowserEvents, TransitionDurations } from './constants';

Swiper.use([Autoplay, Navigation]);

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Next Pages Carousel + Other Product Carousel  ----------

	$('.other-pages-section .section-carousel, .other-products-section:not(.all-champagnes-section) .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				slidesPerView: 'auto',
				spaceBetween: 20,
				breakpoints: {
					// when window width is <= 480px
					480: {
						spaceBetween: 70
					},
					// when window width is <= 768px
					768: {
						spaceBetween: 90
					},
					// when window width is <= 1024px
					1024: {
						spaceBetween: 130
					},
				},
				centeredSlides: true,
				speed: TransitionDurations.default * 2,
				loop: true,
				observer: true,
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});


	// ---------- All Champagne Carousel ----------

	$('.all-champagnes-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				slidesPerView: "auto",
				loop: false,
				spaceBetween: 20,
				breakpoints: {
					// when window width is <= 480px
					480: {
						spaceBetween: 70
					},
					// when window width is <= 768px
					768: {
						spaceBetween: 90
					},
					// when window width is <= 1024px
					1024: {
						spaceBetween: 130
					},
					// when window width is <= 1024px
					1280: {
						spaceBetween: 0
					},
				},
				centeredSlides: true,
				speed: TransitionDurations.default * 2,
				observer: true,
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});


	// ---------- Product Image Rollhover Effect ----------

	$('.product-image').hover(function() {
		const button = $(this).parent().find('.product-infos .btn');
		const buttonRange = $(this).parent().find('.column-content button');

		if(button) {
			button.toggleClass('hover-on');
		}

		else if(buttonRange) {
			buttonRange.toggleClass('hover-on');
		}
	});
});
